import { checkSession, getSession, reactivateAccountResetHashId } from '@engage/api-v2';
import { engageApi } from '../lib/singletons';
import { unwrap } from '../lib/unwrap';
import { toFetcher } from './toFetcher';
export var toAuthFetchers = function toAuthFetchers() {
  var api = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : engageApi;
  return {
    CheckSession: toFetcher(function () {
      return "CheckSession";
    }, function () {
      return unwrap(function () {
        return checkSession(api);
      });
    }),
    GetSession: toFetcher(function () {
      return "GetSession";
    }, function () {
      return unwrap(function () {
        return getSession(api);
      });
    }),
    ReactivateAccount: toFetcher(function (params) {
      return "ReactivateAccount".concat(params.resetHashId);
    }, function (params) {
      return unwrap(function () {
        return reactivateAccountResetHashId(api, params.resetHashId);
      });
    })
  };
};